import { render, staticRenderFns } from "./ResultBlock.vue?vue&type=template&id=ebc5cba4"
import script from "./ResultBlock.vue?vue&type=script&lang=js"
export * from "./ResultBlock.vue?vue&type=script&lang=js"
import style0 from "./ResultBlock.vue?vue&type=style&index=0&id=ebc5cba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports